import { Link } from 'react-router-dom';
import { Heart, Github, MessageCircle } from 'lucide-react';
import { BOT_CONFIG } from '../config/bot';
import BotAvatar from './BotAvatar';

const footerLinks = [
  { to: '/', label: 'Home' },
  { to: '/commands', label: 'Commands' },
  { to: '/contact', label: 'Contact' },
];

const Footer = () => {
  return (
    <footer className="relative mt-auto">
      {/* Top gradient line */}
      <div className="h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* Brand */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full overflow-hidden ring-1 ring-white/[0.06]">
              <BotAvatar className="w-full h-full object-cover" size={32} />
            </div>
            <span className="text-sm font-display font-bold text-gradient">{BOT_CONFIG.name}</span>
          </div>

          {/* Nav */}
          <nav className="flex items-center gap-6">
            {footerLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm text-gray-500 hover:text-gray-200 transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Social */}
          <div className="flex items-center gap-2">
            <a
              href={BOT_CONFIG.supportServer}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-gray-500 hover:text-primary rounded-lg hover:bg-white/[0.04] transition-all"
              title="Discord"
            >
              <MessageCircle className="w-4 h-4" />
            </a>
            <a
              href="https://github.com/Anya-Devs/Anya-Bot"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-gray-500 hover:text-white rounded-lg hover:bg-white/[0.04] transition-all"
              title="GitHub"
            >
              <Github className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 pt-6 border-t border-white/[0.04] flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-gray-600">
          <p className="flex items-center gap-1.5">
            Made with <Heart className="w-3 h-3 text-primary/50 fill-primary/20" /> by Anya Devs
          </p>
          <p>&copy; {new Date().getFullYear()} {BOT_CONFIG.name}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
